import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { z } from 'zod';
import { authApi } from '@/api';
import { ORG_SIGN_IN_PATH } from '@/constants/authRoutes';
import { useState } from 'react';
import { showApiError } from '@/utils/apiError';
import { notify } from '@/core/toast/notify';
import { AuthCard } from '@/core/auth/components/AuthCard';
import { AuthInput } from '@/core/auth/components/AuthInput';
import { AuthButton } from '@/core/auth/components/AuthButton';

const schema = z.object({
  email: z.string().email('Enter a valid email'),
});

type FormData = z.infer<typeof schema>;

export function ForgotPasswordPage() {
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>({
    resolver: zodResolver(schema),
  });

  const onSubmit = async (data: FormData) => {
    setLoading(true);
    try {
      await authApi.forgotPassword(data);
      setSent(true);
      notify.success('Check your email for reset instructions');
    } catch (err) {
      showApiError(err, 'Request failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthCard title="Forgot password">
      {sent ? (
        <p className="text-sm text-slate-600 dark:text-slate-400">
          If the email exists, a reset link was sent. Check your inbox.
        </p>
      ) : (
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <AuthInput label="Email" type="email" autoComplete="email" {...register('email')} error={errors.email?.message} />
          <AuthButton type="submit" loading={loading}>
            Send reset link
          </AuthButton>
        </form>
      )}
      <p className="mt-6 text-center text-sm text-slate-500 dark:text-slate-400">
        <Link to={ORG_SIGN_IN_PATH} className="font-medium text-primary-600 hover:underline dark:text-primary-400">
          Back to login
        </Link>
      </p>
    </AuthCard>
  );
}
